
export default {
	place1: [
		{name: "L'éruption de l'Arnet", link: "/#/video/film-BDR-01s"},
		{name: "La coulée refroidie", link: "/bdr/static/360/var_1/360.html"}
	],
	place2: [
		{name: "La coulée se creuse", link: "/bdr/static/360/var_3/360.html"}
	],
	place3: [
		{name: "Tableau des espèces", link: "/#/video/film-tableau-especes-V5"}
	],
	place4: [
		{name: "Les hyènes contre les hommes", link: "https://d19gm1nt00vbau.cloudfront.net/"},
		{name: "La procession", link: "/bdr/static/360/var_4/360.html"}
	],
	place5: [
		{name: "La coulée de boue", link: "/bdr/static/360/var_5/360.html"},
		{name: "L'ouverture du coffre-fort", link: "/bdr/static/360/var_6/360.html"}
	],
	
}


// WEBPACK FOOTER //
// ./src/components/links.js